import { render, staticRenderFns } from "./GamesOverview.vue?vue&type=template&id=09ff934e"
import script from "./GamesOverview.vue?vue&type=script&lang=ts"
export * from "./GamesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports